"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function VerifyForm() {
  const router = useRouter();
  const [value, setValue] = useState("");
  const [error, setError] = useState<string | null>(null);

  function submit(e: React.FormEvent) {
    e.preventDefault();
    const cleaned = value
      .trim()
      .replace(/^0x/i, "")
      .toLowerCase();

    if (!/^[a-f0-9]{64}$/.test(cleaned)) {
      setError(
        "Not a valid SHA-256 fingerprint. Expected 64 hex characters (a-f, 0-9).",
      );
      return;
    }
    setError(null);
    router.push(`/verify/${cleaned}`);
  }

  return (
    <form onSubmit={submit} className="space-y-3">
      <label
        htmlFor="sha-input"
        className="font-mono text-[10px] tracking-[0.22em] uppercase text-muted-foreground block"
      >
        SHA-256 fingerprint
      </label>
      <div className="flex gap-2">
        <Input
          id="sha-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="64 hex characters"
          className="font-mono text-xs bg-background/60"
          aria-invalid={!!error}
        />
        <Button type="submit">Verify →</Button>
      </div>
      {error && (
        <p className="text-xs text-destructive bg-destructive/10 border border-destructive/30 px-3 py-2 rounded-md">
          {error}
        </p>
      )}
      <p className="text-xs text-muted-foreground">
        Compute a SHA-256 of any file with{" "}
        <code className="font-mono">shasum -a 256 file.jpg</code> on
        macOS/Linux or PowerShell&apos;s{" "}
        <code className="font-mono">Get-FileHash -Algorithm SHA256</code>{" "}
        on Windows.
      </p>
    </form>
  );
}
